<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>上架任务</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="search_form"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item label="输入搜索：" prop="search_type">
                  <el-select
                    v-if="resData"
                    v-model="form.search_type"
                    placeholder="搜索条件"
                  >
                    <el-option
                      v-for="item in searchOption"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="keyword">
                  <el-input
                    v-model="form.keyword"
                    placeholder="关键字"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="create_admin">
                  <el-input
                    v-model="form.create_admin"
                    placeholder="创建人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="receive_admin">
                  <el-input
                    v-model="form.receive_admin"
                    placeholder="领取人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="status">
                  <el-select
                    v-if="resData"
                    v-model="form.status"
                    placeholder="状态"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in statusOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="receive_admin">
                  <el-input
                    v-model="form.wave_picking_no"
                    placeholder="波次号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="创建时间：" prop="create_time">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="领取时间：" prop="receive_time">
                  <el-date-picker
                    v-model="form.receive_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="开始时间：" prop="start_time">
                  <el-date-picker
                    v-model="form.start_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="完成时间：" prop="complete_time">
                  <el-date-picker
                    v-model="form.complete_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="提交时间：" prop="submit_time">
                  <el-date-picker
                    v-model="form.submit_time"
                    type="datetimerange"
                    :default-time="['06:00:00', '06:00:00']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item prop="close_admin">
                  <el-select
                    v-model="form.close_admin"
                    placeholder="是否后台关闭"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option value="1" label="是"></el-option>
                    <el-option value="2" label="否"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="task_type">
                  <el-select
                    v-if="resData"
                    v-model="form.task_type"
                    placeholder="任务类型"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in taskTypeOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button
                    type="primary"
                    @click="$refs.search_form.resetFields()"
                    >重置</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="danger"
            size="mini"
            @click="closeBox"
          >
            批量关闭容器</el-button
          >
          <el-button type="primary" size="mini" @click="output(2)">
            导出上架单明细</el-button
          >
          <el-button style="" type="success" size="mini" @click="output(1)">
            导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            :cell-style="{ padding: '2px 0' }"
            @selection-change="handleSelection"
          >
            <el-table-column align="center" type="selection"></el-table-column>
            <el-table-column
              prop="us_no"
              label="上架单号"
              show-overflow-tooltip
              align="center"
              width="120"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              prop="task_type"
              label="任务类型"
              show-overflow-tooltip
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="box_no"
              label="容器号"
              show-overflow-tooltip
              align="center"
              width="120"
            >
              <template #default="scope">
                <div type="text" @click="openBarCode(scope.row.box_no)">
                  {{ scope.row.box_no }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_name"
              label="创建人"
              width="100"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              show-overflow-tooltip
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="任务数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="num_ok"
              label="已上架数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wave_picking_no"
              label="波次号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="receive_name"
              label="领取人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="receive_time"
              label="领取时间"
              show-overflow-tooltip
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="start_time"
              label="开始上架时间"
              show-overflow-tooltip
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="submit_time"
              label="提交时间"
              show-overflow-tooltip
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="complete_time"
              label="完成时间"
              show-overflow-tooltip
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="任务待领取时长"
              show-overflow-tooltip
              align="center"
              width="180"
            >
              <template #default="scope">
                <div v-if="scope.row.create_time">
                  <!--时长以分钟为单位向上取整整-->
                  <!--待领取-->
                  <div v-if="scope.row.status === UPSHELF_STATUS.UNRECEIVED">
                    {{
                      Math.ceil(
                        (dayjs().unix() - dayjs(scope.row.create_time).unix()) /
                          60
                      )
                    }}分钟
                  </div>
                  <!--已领取-->
                  <div
                    v-if="
                      scope.row.status === UPSHELF_STATUS.RECEIVED &&
                      scope.row.receive_time
                    "
                  >
                    {{
                      Math.ceil(
                        (dayjs(scope.row.receive_time).unix() -
                          dayjs(scope.row.create_time).unix()) /
                          60
                      )
                    }}分钟
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="upshelf_status"
              label="状态"
              show-overflow-tooltip
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="is_admin_close"
              label="是否后台关闭"
              show-overflow-tooltip
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="exception_name"
              label="异常处理人员"
              width="100"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="exception_time"
              label="异常处理时间"
              width="180"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="except"
              label="异常数据"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="package_no"
              label="点货包裹"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" prop="goods_name" fixed="right">
              <template #default="scope">
                <el-button
                  v-if="scope.row.status == 3"
                  type="text"
                  @click="unbind(scope.row)"
                  >解绑</el-button
                >
                <el-button type="text" @click="showDbids(scope.row)">
                  详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="currentPage"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.total"
            :page-size="10"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Global_ from "../components/Global.vue";
import apiBaseURL from "@/utils/baseUrl.js";
import * as upshelfApi from "@/openapi/erp/upshelf.js";
// 已领取
// 未领取
const UPSHELF_STATUS = {
  RECEIVED: "3",
  UNRECEIVED: "2",
};

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getOptionsForUpshelfList();
      vm.fetchData();
    });
  },
  data() {
    return {
      dayjs,
      UPSHELF_STATUS,
      resData: null,
      form: {
        origin: 1,
        close_admin: "",
        search_type: "",
        keyword: "",
        create_admin: "",
        receive_admin: "",
        receive_time: [],
        start_time: [],
        complete_time: [],
        submit_time: [],
        task_type: "",
        create_time: this.defaultDate(),
        wave_picking_no: "", // 波次号
      },
      loading: false,
      url: "/erp/Upshelf/getList",
      origin: [
        { key: 1, label: "广州" },
        { key: 2, label: "杭州" },
      ],
      searchOption: [
        { key: 1, label: "上架单" },
        { key: 2, label: "容器号" },
        { key: 3, label: "sku编号" },
        { key: 4, label: "打标id" },
      ],
      currentPage: 1,
      tableLoading: false,
      filterFold: false,
      statusOption: [],
      taskTypeOption: [],
      selection: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    getOptionsForUpshelfList() {
      upshelfApi.getOptionsForUpshelfList().then((res) => {
        const { statusOption, taskTypeOption } = res;
        this.statusOption = statusOption;
        this.taskTypeOption = taskTypeOption;
      });
    },
    openBarCode(text) {
      if (Global_.environment === 0) {
        this.$alert(
          `<img src="https://erp.yishouapp.com/barcode.php?text=${text}" />`,
          "",
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false,
            closeOnClickModal: true,
            center: true,
          }
        );
      }
    },
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    output(id) {
      this.form.is_excel = id;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.currentPage = 1;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    unbind(row) {
      const url = "/erp/Upshelf/unbind";
      this.$http.post(url, { us_id: row.us_id }).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.fetchData();
        }
      });
    },
    showDbids(row) {
      const id = row.us_id;
      this.$router.push(`/home/UpshelfDetail/${id}`);
    },
    defaultDate() {
      const defaultSerachData = 7; // 默认查询的时间天数
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - defaultSerachData);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },

    // 批量关闭容器
    closeBox() {
      const f = () => {
        this.$http
          .post("/erp/Upshelf/closeBoxOnUpshelf", {
            us_ids: this.selection,
          })
          .then((rs) => {
            if (rs.data.code != 200) return this.$message.error(rs.data.msg);
            this.fetchData(true);
            console.log(rs.data.data.fail);
            let msg = "";
            rs.data.data.fail.forEach((v) => {
              msg += `${v.us_no}关闭失败, ${v.msg}; `;
            });
            this.$confirm(
              `已关闭${rs.data.data.success_count}个容器; ${msg}`,
              "批量关闭容器",
              {
                closeOnClickModal: false,
                showCancelButton: false,
              }
            );
          });
      };
      if (this.selection.length == 0)
        return this.$message.error("请选择上架单");
      this.$confirm(`是否批量关闭容器`, "批量关闭容器").then((_) => f());
    },

    // 选中
    handleSelection(rows) {
      this.selection.length = 0;
      rows.forEach((v) => {
        this.selection.push(v.us_id);
      });
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/UpshelfList.vue